import { Teaser } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/teasers/teasers.state'
import { TeasersView } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/teasers/teasers.template'
import { Paginator } from '@shared/Frontend/components/paginator'
import { t } from 'i18next'
import React, { useRef } from 'react'
import { TeaserGridItem, TeaserItem } from './teaser'
import { getSite } from '@shared/Frontend/utils/site'
import { translate } from "@shared/Frontend/utils/translate"

const site = getSite()

export const Teasers: TeasersView['Teasers'] = ({ page, totalPages, type, items }) => {
  const ref = useRef<HTMLDivElement>(null)
  return (
    <div className="overview__content" ref={ref}>
      <OverviewItems type={type} items={items} />
      <Paginator currentPage={page} totalPages={totalPages} scrollToRef={ref} />
    </div>
  )
}

const OverviewItems = ({ type, items }: { type: 'search' | 'person' | 'news' | 'standpoints' | 'our-other-views'; items: Teaser[] }) => {
  switch (type) {
    case 'search':
      return <SearchOverviewItems items={items} />
    case 'news':
      return <NewsOverviewItems items={items} />
    case 'person':
      return <></>
    case 'our-other-views':
      return <OurViewOverviewItems items={items} />
    case 'standpoints':
      return <StandpointsOverviewItems items={items} />
  }
}

const SearchOverviewItems = ({ items }: { items: Teaser[] }) => (
  <ul className="overview__list teasers ls-spacing">
    {items.length < 1 && <li>{translate('overviews:noresults', {}, '')}</li>}
    {items.map((item) => (
      <TeaserItem
        {...item}
        showType={site == 'ZEG' ? false : true}
        extraClasses='teaser--search'
        titleExtraClasses={site == 'ZEG' ? 'text--m' : 'title--sm' }
      />
    ))}
  </ul>
)


const NewsOverviewItems = ({ items }: { items: Teaser[] }) => (
  <ul className="overview__list grid gridsys--grid ls-spacing">
    {items.length < 1 && <li>{translate('overviews:noresults', {}, '')}</li>}
    {items.map((item) => (
      <TeaserGridItem
        {...item}
        showType={false}
      />
    ))}
  </ul>
)

const StandpointsOverviewItems = ({ items }: { items: Teaser[] }) => (
  <ul className="overview__list grid grid--standpoints">
    {items.length < 1 && <li>{translate('overviews:noresults', {}, '')}</li>}
    {items.map((item) => (
      <TeaserItem
        {...item}
        showType={false}
        titleExtraClasses={'title--sm' }
      />
    ))}
  </ul>
)

const OurViewOverviewItems = ({ items }: { items: Teaser[] }) => (
  <ul className="overview__list grid grid--ourview">
    {items.length < 1 && <li>{translate('overviews:noresults', {}, '')}</li>}
    {items.map((item) => (
      <TeaserItem
        {...item}
        showType={false}
        titleExtraClasses={'title--sm' }
      />
    ))}
  </ul>
)
